export const EMAIL_COMMUNICATION_ID = 1;
export const SMS_COMMUNICATION_ID = 6;

export const EMP_TYPE_FULLTIME = 1;
export const EMP_TYPE_PARTTIME = 2;
export const EMP_TYPE_CONTRACT = 3;
export const EMP_TYPE_VENDOR = 4;

export const TRAUMA_SERVICES = [
    // English text
    "Debriefing",
    "Defusing",
    "Outreach Calls",
    "On-Site Support",
    "Off Worksite Incident",
    "Peer Support Triage & Coordination",
    "Trauma Consultation",
    "Worksite Incident",
    "Critical Incident Stress Management",
    // French text
    "Séance de verbalisation",
    "Séance de désamorçage",
    "Soutien sur les lieux",
    "Appels de suivi",
    "Incidents sur le terrain",
    "Triage et coordination en vue d’une intervention par des pairs",
    "Consultation en intervention post-traumatique",
    "Incidents sur les lieux de travail",
];